import { NavLink } from "react-router-dom";
import { Divider, Grid, Header, Responsive, Tab } from "semantic-ui-react";
import FindPengeinstitut from "../../images/IkonHerfaarDuLetsikringer.svg";
import TjekDinPension from "../../images/IkonTjekDinPension.svg";
import withSizes from "react-sizes";
import appRoutes from "../../routes/appRoutes";
import { Route } from "react-router";
import CallForAction from "../common/CallForAction";

const mapSizesToProps = ({ width }) => ({
  tablet: width < Responsive.onlyTablet.minWidth,
});

const Investering = (props) => {
  const { tablet } = props;
  const invfiler = [
    {
      headline: "Investeringsprofil A",
      filnavn: "Investeringsprofil_A_2025-01-01",
    },
    {
      headline: "Investeringsprofil B",
      filnavn: "Investeringsprofil_B_2025-01-01",
    },
    {
      headline: "Investeringsprofil C",
      filnavn: "Investeringsprofil_C_2025-01-01",
    },
    {
      headline: "Investeringsprofil D",
      filnavn: "Investeringsprofil_D_2025-01-01",
    },
    {
      headline: "Investeringsprofil Klima A",
      filnavn: "Investeringsprofil_Klima_A_2025-01-01",
    },
    {
      headline: "Investeringsprofil Klima B",
      filnavn: "Investeringsprofil_Klima_B_2025-01-01",
    },
    {
      headline: "Investeringsprofil Klima C",
      filnavn: "Investeringsprofil_Klima_C_2025-01-01",
    },
    {
      headline: "Investeringsprofil Klima D",
      filnavn: "Investeringsprofil_Klima_D_2025-01-01",
    },
    {
      headline: "Investeringsprofil Høj Risiko Fonden",
      filnavn: "Investeringskoncept_Hoej_Risiko_Fonden_2025-01-01",
    },
    {
      headline: "Investeringsprofil Lav Risiko Fonden",
      filnavn: "Investeringskoncept_Lav_Risiko_Fonden_2025-01-01",
    },
    {
      headline: "Investeringsprofil Klima Høj Risiko Fonden",
      filnavn: "Investeringskoncept_Klima_Hoej_Risiko_Fonden_2025-01-01",
    },
    {
      headline: "Investeringsprofil Klima Lav Risiko Fonden",
      filnavn: "Investeringskoncept_Klima_Lav_Risiko_Fonden_2025-01-01",
    },
  ];
  const panes = [
    {
      menuItem: {
        as: NavLink,
        to: appRoutes.INVESTERING_AFKAST,
        exact: true,
        icon: "line chart",
        content: tablet ? null : "Investering og afkast",
        key: "invafkast",
      },
      pane: (
        <Route
          path={appRoutes.INVESTERING_AFKAST}
          key={appRoutes.INVESTERING_AFKAST}
          exact
          render={() => (
            <Tab.Pane>
              <Grid>
                <Grid.Row columns={tablet ? 1 : 2}>
                  <Grid.Column>
                    <h4>Hvordan bliver mine penge investeret?</h4>
                    <p>
                      Når du køber en Letsikring af indtægt ved pension, bliver
                      din opsparing investeret i markedsrente, dvs. i en
                      blanding af aktier, obligationer, ejendomme og alternative
                      investeringer. Alle investeringer foregår via fire fonde:
                      Lav risiko fonden, Høj risiko fonden, Klima Lav risiko
                      fonden og Klima Høj risiko fonden.
                    </p>
                    <p>
                      Alt efter din risiko og klimapræference er fordelingen
                      mellem fondene forskellig. Potentialet for afkast hænger
                      sammen med risiko: Jo højere risiko, des større potentiale
                      for højt afkast og omvendt.
                    </p>
                    <h4>Se dit afkast</h4>
                    <p>
                      Du kan se dit afkast i{" "}
                      <a
                        href="https://www.letportal.dk"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Letportalen
                      </a>{" "}
                      eller via din mobil- eller netbank.
                    </p>
                    <p>
                      <a
                        className="link"
                        target="_blank"
                        rel="noopener noreferrer"
                        href="/dokumenter/afkast"
                      >
                        Se PFA's investeringsafkast.
                      </a>
                    </p>
                  </Grid.Column>
                  <Grid.Column>
                    <h4>PFA KundeKapital</h4>
                    <p>
                      Du kan vælge, at en del af dine løbende indbetalinger,
                      indskud og overførsler til din opsparing skal gå til PFA
                      KundeKapital, som er ansvarlig kapital i PFA Pension. Du
                      kan ikke vælge, hvordan din opsparing i PFA KundeKapital
                      bliver investeret.
                    </p>
                    <p>Du kan læse mere under fanen ”PFA KundeKapital”.</p>

                    <h4>Risikomærkning</h4>
                    <p>
                      Brancheorganisation for forsikrings- og pensionsselskaber
                      i Danmark, F&P, har lavet et værktøj, hvor du kan
                      sammenligne risikoen på tværs af pensionsselskaber. Med
                      dette værktøj kan du se risikoen i dit eget
                      pensionsprodukt og sammenligne den med gennemsnittet af
                      risikoen for pensionsprodukter i markedsrente på tværs af
                      pensionsselskaber.
                    </p>
                    <p>
                      <a
                        className="link"
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.faktaompension.dk/risiko"
                      >
                        Gå til F&P’s værktøj Min Pensionsrisiko
                      </a>
                    </p>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Tab.Pane>
          )}
        />
      ),
    },
    {
      menuItem: {
        as: NavLink,
        to: appRoutes.INVESTERING_KONCEPTER,
        exact: true,
        icon: "pie chart",
        content: tablet ? null : "Investeringskoncepter",
        key: "profiler",
      },
      pane: (
        <Route
          path={appRoutes.INVESTERING_KONCEPTER}
          key={appRoutes.INVESTERING_KONCEPTER}
          exact
          render={() => (
            <Tab.Pane>
              <Grid>
                <Grid.Row columns={tablet ? 1 : 2}>
                  <Grid.Column>
                    <p>
                      Der er altid en risiko ved at investere, fordi markederne
                      går op og ned. Det handler om at mærke efter, hvilken
                      risiko du er villig til at løbe i forhold til det afkast,
                      du har mulighed for at få. Du kan vælge mellem to
                      investeringskoncepter:
                    </p>
                    <h4>Investeringskonceptet Livscyklus</h4>
                    <p>
                      I investeringskonceptet Livscyklus kan du vælge mellem tre
                      investeringsprofiler: Profil Lav, Profil Middel og Profil
                      Høj.
                    </p>
                    <p>
                      De tre profiler har forskellige potentialer for et godt
                      afkast og forskellige grader af risiko knyttet til sig.
                      Profil Lav har den laveste risiko og det mindste
                      potentiale for et højt afkast. Profil Høj har den bedste
                      mulighed for et højt afkast, men også den højeste risiko.
                    </p>
                    <p>
                      Investeringsprofilerne bygger på PFA’s Lav risiko fonde og
                      PFA’s Høj risiko fonde. Jo højere investeringsrisiko
                      profilen har, des større andel af investeringerne kommer
                      fra Høj risiko fondene.
                    </p>
                    <p>
                      Uanset hvilken investeringsprofil du vælger, vil din
                      investeringsrisiko blive nedtrappet i takt med, du bliver
                      ældre. Det sker for at reducere risikoen for store dyk i
                      opsparingen i sidste del af opsparingsperioden, hvor
                      behovet for tryghed vokser, og du har begrænset tid til at
                      vinde eventuelle tab tilbage.
                    </p>
                  </Grid.Column>
                  <Grid.Column>
                    <h4>Investeringskonceptet Fleksibel</h4>
                    <p>
                      I investeringskonceptet Fleksibel fastsætter du selv den
                      samlede risiko for din opsparing. Det gør du ved at vælge
                      fordelingen mellem PFA’s Lav risiko fonde og PFA’s Høj
                      risiko fonde.{" "}
                    </p>
                    <p>
                      Modsat investeringskonceptet Livscyklus bliver risikoen i
                      Fleksibel ikke automatisk nedtrappet i takt med din alder.
                      Du skal derfor selv være opmærksom på løbende at tilpasse
                      risikoen, hvis du ønsker, at den er tilpasset din alder og
                      situation.
                    </p>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Tab.Pane>
          )}
        />
      ),
    },
    {
      menuItem: {
        as: NavLink,
        to: appRoutes.INVESTERING_FONDE,
        exact: true,
        icon: "bar chart",
        content: tablet ? null : "Investeringsfonde",
        key: "invfonde",
      },
      pane: (
        <Route
          path={appRoutes.INVESTERING_FONDE}
          key={appRoutes.INVESTERING_FONDE}
          exact
          render={() => (
            <Tab.Pane>
              <Grid>
                <Grid.Row columns={tablet ? 1 : 2}>
                  <Grid.Column>
                    <p>
                      Alle investeringer foregår via fire fonde: Lav risiko
                      fonden, Høj risiko fonden, Klima Lav risiko fonden og
                      Klima Høj risiko fonden. Det er PFA, som står for
                      investeringen.{" "}
                    </p>
                    <p>
                      I Lav risiko fondene og Høj risiko fondene investeres der
                      i aktier, obligationer, ejendomme og alternative
                      investeringer. For alle fonde gælder, at investeringen
                      sker bredt på tværs af sektorer og geografi for at sprede
                      risikoen mest muligt, og de bliver løbende tilpasset i
                      forhold til markedssituationen.{" "}
                    </p>
                  </Grid.Column>
                  <Grid.Column>
                    <p>
                      Høj risiko fondene investerer hovedsageligt i aktier og
                      tilsvarende investeringer, og investeringerne er derfor
                      primært orienteret mod børsnoterede og private selskaber
                      samt infrastruktur med høj risiko.
                    </p>
                    <p>
                      Lav risiko fondene investerer primært i obligationer og
                      tilsvarende investeringer. Dette er bl.a.
                      kreditobligationer, statsobligationer, infrastruktur,
                      ejendomme og skov.
                    </p>

                    <h4>Beholdningslister</h4>
                    <p>
                      <a
                        target="_blank"
                        className="link"
                        rel="noopener noreferrer"
                        href="/dokumenter/aktier"
                      >
                        Aktieliste (PDF)
                      </a>
                      <br />
                      <a
                        target="_blank"
                        className="link"
                        rel="noopener noreferrer"
                        href="/dokumenter/obligationer"
                      >
                        Obligationsliste (PDF)
                      </a>
                      <br />
                      <a
                        target="_blank"
                        className="link"
                        rel="noopener noreferrer"
                        href="/dokumenter/statsobligationer"
                      >
                        Landeliste over statsobligationer (PDF)
                      </a>
                      <br />
                      <a
                        target="_blank"
                        className="link"
                        rel="noopener noreferrer"
                        href="/dokumenter/alternativeinvesteringer"
                      >
                        Liste over alternative investeringer og ejendomme (PDF)
                      </a>
                      <br />
                    </p>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Tab.Pane>
          )}
        />
      ),
    },
    {
      menuItem: {
        as: NavLink,
        to: appRoutes.INVESTERING_KUNDEKAPITAL,
        exact: true,
        icon: "users",
        content: tablet ? null : "PFA KundeKapital",
        key: "kundekapital",
      },
      pane: (
        <Route
          path={appRoutes.INVESTERING_KUNDEKAPITAL}
          key={appRoutes.INVESTERING_KUNDEKAPITAL}
          exact
          render={() => (
            <Tab.Pane>
              <Grid>
                <Grid.Row columns={tablet ? 1 : 2}>
                  <Grid.Column>
                    <p>
                      Du kan vælge, at en del af dine løbende indbetalinger,
                      indskud og overførsler skal gå til PFA KundeKapital, som
                      er PFA’s model for risiko- og overskudsdeling.
                    </p>
                    <p>
                      KundeKapital er ansvarlig kapital i PFA Pension, hvilket
                      betyder, at KundeKapital får en andel i såvel overskud som
                      tab i PFA Pension. I gode tider giver det mulighed for at
                      få en høj forrentning af KundeKapital. I dårlige tider kan
                      KundeKapitalen blive mindre (negativ forrentning) og i
                      yderste konsekvens tabes helt.{" "}
                    </p>
                  </Grid.Column>
                  <Grid.Column>
                    <p>
                      Læs mere på{" "}
                      <a
                        className="link"
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.pfa.dk/privat/opsparing/pfa-kundekapital/"
                      >
                        https://www.pfa.dk/privat/opsparing/pfa-kundekapital/
                      </a>
                    </p>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Tab.Pane>
          )}
        />
      ),
    },
    {
      menuItem: {
        as: NavLink,
        to: appRoutes.INVESTERING_KLIMA,
        exact: true,
        icon: "envira",
        content: tablet ? null : "Klima",
        key: "klima",
      },
      pane: (
        <Route
          path={appRoutes.INVESTERING_KLIMA}
          key={appRoutes.INVESTERING_KLIMA}
          exact
          render={() => (
            <Tab.Pane>
              <Grid>
                <Grid.Row columns={tablet ? 1 : 2}>
                  <Grid.Column>
                    <p>
                      PFA arbejder systematisk med at integrere hensyn til klima
                      og miljø, selskabsledelse og social ansvarlighed i alle
                      investeringer. Derudover inddrages i alle PFA’s produkter
                      overholdelse af internationale normer for ansvarlighed
                      inden for blandt andet menneskerettigheder,
                      arbejdstagerrettigheder, miljø og anti-korruption.
                    </p>
                    <p>
                      PFA tilbyder en opsparingsmulighed, der har ekstra fokus
                      på klima. Investeringen foregår i Klima Høj risiko fond og
                      Klima Lav risiko fond.
                    </p>
                    <p>
                      Klima fondene fremmer den grønne omstilling ved i
                      forbindelse med udvælgelsen af investeringerne at have
                      fokus på det bedst mulige afkast samt virksomhedernes
                      fokus på omstilling af økonomien til en
                      lavemissions-økonomi og dermed reduktion af CO<sub>2</sub>
                      -udledning til gavn for klimaet.
                    </p>
                  </Grid.Column>
                  <Grid.Column>
                    <p>
                      De skærpede krav til investeringerne i Klima fondene gør,
                      at investeringsuniverset er mere begrænset end i den
                      øvrige opsparing i PFA. Det betyder, at du ved samme
                      profil, dvs. i en tilsvarende investeringsrisiko, må
                      forvente et lidt lavere afkast og større udsving på kort
                      sigt end i de øvrige investeringer, som ikke er Klima. I
                      praksis kan afkastet dog både blive højere, det samme
                      eller lavere.
                    </p>
                    <p>
                      Du vælger selv, hvor stor en andel af din opsparing der
                      skal være ekstra klimavenlig.
                    </p>
                    <p>
                      <a className="link" href="/klima">
                        Læs mere om ekstra klimavenlige investeringer.
                      </a>
                    </p>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Tab.Pane>
          )}
        />
      ),
    },
    {
      menuItem: {
        as: NavLink,
        to: appRoutes.INVESTERING_BAEREDYGTIGHED,
        exact: true,
        icon: "recycle",
        content: tablet ? null : "Bæredygtighedsrelaterede oplysninger",
        key: "baeredygtighed",
      },
      pane: (
        <Route
          path={appRoutes.INVESTERING_BAEREDYGTIGHED}
          key={appRoutes.INVESTERING_BAEREDYGTIGHED}
          exact
          render={() => (
            <Tab.Pane>
              <Grid>
                <Grid.Row columns={tablet ? 1 : 2}>
                  <Grid.Column>
                    <h4>Investering og bæredygtighed</h4>
                    <p>
                      EU har som del af arbejdet med bæredygtig økonomi vedtaget
                      rammer for, hvordan udbydere af finansielle produkter skal
                      klassificere, dokumentere, rådgive og kommunikere om
                      bæredygtighed i forhold sine finansielle produkter,
                      herunder pensionsprodukter. Disse rammer er nærmere
                      beskrevet i EU’s disclosureforordning.{" "}
                    </p>
                    <p>
                      Derfor har PFA lavet en bæredygtighedsbeskrivelse for hver
                      type af investeringsprofil og investeringskoncept. Du kan
                      se dem på siden her.
                    </p>
                  </Grid.Column>
                  <Grid.Column>
                    <h4>Prækontraktuel information efter 1/4-2025</h4>
                    <a
                      target="_blank"
                      className="link"
                      rel="noopener noreferrer"
                      href={
                        "/dokumenter/Praekontrakt_info_Investeringsprofil_Forsigtig_2025-04-01"
                      }
                    >
                      Investeringsprofil Forsigtig
                    </a>
                    <br />
                    <a
                      target="_blank"
                      className="link"
                      rel="noopener noreferrer"
                      href={
                        "/dokumenter/Praekontrakt_info_InvesteringsProfil_Lav_2025-04-01"
                      }
                    >
                      Investeringsprofil Lav
                    </a>
                    <br />
                    <a
                      target="_blank"
                      className="link"
                      rel="noopener noreferrer"
                      href={
                        "/dokumenter/Praekontrakt_info_Investeringsprofil_Middel_2025-04-01"
                      }
                    >
                      Investeringsprofil Middel
                    </a>
                    <br />
                    <a
                      target="_blank"
                      className="link"
                      rel="noopener noreferrer"
                      href={
                        "/dokumenter/Praekontrakt_info_Investeringsprofil_Hoej_2025-04-01"
                      }
                    >
                      Investeringsprofil Høj
                    </a>
                    <br />
                    <a
                      target="_blank"
                      className="link"
                      rel="noopener noreferrer"
                      href={
                        "/dokumenter/Praekontrakt_info_Investeringsprofil_Klima_Forsigtig_2025-04-01"
                      }
                    >
                      Investeringsprofil Klima Forsigtig
                    </a>
                    <br />
                    <a
                      target="_blank"
                      className="link"
                      rel="noopener noreferrer"
                      href={
                        "/dokumenter/Praekontrakt_info_InvesteringsProfil_Klima_Lav_2025-04-01"
                      }
                    >
                      Investeringsprofil Klima Lav
                    </a>
                    <br />
                    <a
                      target="_blank"
                      className="link"
                      rel="noopener noreferrer"
                      href={
                        "/dokumenter/Praekontrakt_info_Investeringsprofil_Klima_Middel_2025-04-01"
                      }
                    >
                      Investeringsprofil Klima Middel
                    </a>
                    <br />
                    <a
                      target="_blank"
                      className="link"
                      rel="noopener noreferrer"
                      href={
                        "/dokumenter/Praekontrakt_info_Investeringsprofil_Klima_Hoej_2025-04-01"
                      }
                    >
                      Investeringsprofil Klima Høj
                    </a>
                    <br />
                    <a
                      target="_blank"
                      className="link"
                      rel="noopener noreferrer"
                      href={
                        "/dokumenter/Praekontrakt_info_Investeringskoncept_Klima_Hoej_Risiko_Fonden_2025-04-01"
                      }
                    >
                      Investeringsprofil Klima Høj Risiko Fonden
                    </a>
                    <br />
                    <h4>Information før 1/4-2025</h4>
                    <p>
                      {invfiler.map((x, i) => {
                        return (
                          <span key={i}>
                            {x.headline}
                            <br />
                            <a
                              target="_blank"
                              className="link"
                              rel="noopener noreferrer"
                              href={
                                "/dokumenter/Praekontrakt_info_" + x.filnavn
                              }
                            >
                              Prækontraktuel information
                            </a>
                            <br />
                            <a
                              target="_blank"
                              className="link"
                              rel="noopener noreferrer"
                              href={"/dokumenter/" + x.filnavn}
                            >
                              Bæredygtighedsrelaterede oplysninger
                            </a>
                            <br />
                            <a
                              target="_blank"
                              className="link"
                              rel="noopener noreferrer"
                              href={"/dokumenter/Sammenfatning_" + x.filnavn}
                            >
                              Sammenfatning - Bæredygtighedsrelaterede
                              oplysninger
                            </a>
                            <br />
                            <a
                              target="_blank"
                              className="link"
                              rel="noopener noreferrer"
                              href={
                                "/dokumenter/Periodiskrapportering_" + x.filnavn
                              }
                            >
                              Periodisk rapportering
                            </a>
                            <br />
                            <br />
                          </span>
                        );
                      })}
                    </p>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Tab.Pane>
          )}
        />
      ),
    },
  ];

  return (
    <div>
      <Header as="h2" textAlign="center">
        Sådan bliver dine penge investeret
      </Header>
      <Divider hidden />
      <p>
        Letpension formidler pensions- og forsikringsløsninger for PFA Pension.
      </p>
      <p>
        PFA leverer pensions- og forsikringsprodukterne og står for
        investeringen af de opsparede penge.
      </p>

      <Tab renderActiveOnly={false} activeIndex={-1} panes={panes} />
      <Divider section hidden />

      <Grid centered stackable columns={2}>
        <Grid.Row>
          <CallForAction
            icon={FindPengeinstitut}
            color="#e49d3b"
            text="Her får du Letsikringer"
            link={appRoutes.BLIV_KUNDE}
          />
          <CallForAction
            icon={TjekDinPension}
            color="#b9c35d"
            text="Tjek din pension"
            link={appRoutes.TJEK_DIN_PENSION}
          />
        </Grid.Row>
      </Grid>
    </div>
  );
};

export default withSizes(mapSizesToProps)(Investering);
